<template>
   <div class="support-wrapper mt-5">
      <v-container class="custom-container responsive-height">
         <v-row dense align="center" class="mb-5">
            <v-col sm="4" md="4">
               <v-text-field 
                  v-model="search" 
                  prepend-icon="mdi-magnify" 
                  label="Search anything here ..." 
                  single-line 
                  solo
                  hide-details 
                  class="input-search"
                  ></v-text-field>
            </v-col>
            <v-col v-if="filteredTickets?.length > 0" sm="6" md="6" class="d-none d-flex custom-date-year">
               <v-card-title class="title-text py-0">
                  {{ ticketDetails.subject }}
                  <span class="ml-3">{{ moment(ticketDetails?.created_at).format("MMMM Do YYYY") }}</span>
               </v-card-title>
            </v-col>
            <v-col sm="2" md="2" class="support-btn-col">
               <v-dialog
                  v-model="dialog"
                  transition="scale-transition"
                  origin="center center"
                  max-width="600px"
                  content-class="deposit-modal"
                  >
                  <template v-slot:activator="{ on, attrs }">
                     <v-btn 
                        small 
                        tile 
                        elevation="0" 
                        class="text-capitalize btn-account" 
                        color="greenMain" 
                        v-bind="attrs"
                        v-on="on"
                        >
                        New Support
                     </v-btn>
                  </template>
                  <v-card 
                     rounded="0" 
                     class="auth-modal-card"
                     :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'"
                     >
                     <v-card-title class="justify-center">Create New Support</v-card-title>
                     <v-card-text class="px-0 mb-0 pb-0">
                        <v-form>
                           <v-select 
                              v-model="selectedOption" 
                              :items="options" 
                              label="Select Topic"
                              class="custom-select mb-2"
                              hide-details
                              single-line
                              solo
                              ></v-select>
                           <v-text-field 
                              v-if="selectedOption === 'Others'" 
                              v-model="subject"
                              placeholder="Enter the reason"
                              hide-details
                              single-line
                              solo
                              ></v-text-field>
                           <v-textarea 
                              v-model="description" 
                              placeholder="Enter a description"
                              class="custom-textarea"
                              hide-details
                              single-line
                              solo
                              ></v-textarea>
                        </v-form>
                     </v-card-text>
                     <v-divider></v-divider>
                     <v-card-actions class="px-0 pb-0">
                        <v-btn 
                           @click.prevent="createTicket" 
                           class="elevation-0"
                           :color="$vuetify.theme.dark ? '#FF567F' : '#FF567F'"
                           >Create</v-btn>
                        <v-btn 
                           @click="dialog = false" 
                           class="elevation-0" 
                           :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'"
                           outlined
                           >Cancel</v-btn>
                     </v-card-actions>
                  </v-card>
               </v-dialog>
            </v-col>
         </v-row>
         <v-card v-if="filteredTickets?.length === 0" color="greenMain" dark width="400">
            <v-card-text>
               Currently, there hasn't been any conversation initiated. To initiate a
               new conversation, please feel free to start a new support request.
            </v-card-text>
         </v-card>
         <v-tabs 
            class="support-tabs" 
            vertical 
            :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
            v-model="selectedTab"
            >
            <v-tab 
               v-for="(ticket, index) in filteredTickets" 
               :key="index" 
               class="text-left justify-start support-tab"
               @click.prevent="selectTicket(ticket,index)"
               >
               <p class="mb-0">
                  <v-text>{{ ticket.subject }}</v-text>
                  <span class="d-block">{{ ticket?.description?.slice(0, 50) + "..." }}</span>
                  <span class="d-block">{{ moment(ticket?.created_at).format("ddd MMM, YYYY") }}</span>
                  <span class="ticket-circle-text" v-if="ticket.status == 2">
                  Closed
                  </span>
               </p>
            </v-tab>
            <v-tab-item 
               v-for="(ticket, index) in filteredTickets" 
               :key="index" 
               class="bg-transparent"
               >
               <v-card 
                  ref="messageCard" 
                  :key="index" 
                  class="support-card support-card__details"
                  flat 
                  :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
                  >
                  <v-alert class="custom-alert bg-success"
                     :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
                     <p>{{ ticket?.description }}</p>
                  </v-alert>
                  <div v-for="(comment, index) in ticketDetails?.ticketcomments" :key="index">
                     <!-- ADMIN -->
                     <v-row v-if="comment.is_admin_comment === 1" dense>
                        <v-col cols="2" sm="2" md="1">
                           <v-avatar size="31" class="mx-auto">
                              <img src="../../assets/avatar.png" alt="Admin" />
                           </v-avatar>
                        </v-col>
                        <v-col sm="10" cols="10" md="10">
                           <v-card
                              flat
                              :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
                              >
                              <v-card-title>
                                 <p>
                                    Support
                                    <span class="ml-4">{{ moment(comment.created_at).fromNow() }}</span>
                                 </p>
                              </v-card-title>
                              <v-card-text>
                                 <p class="bg-theme">{{ comment.comment }} <v-img
                                       v-if="comment.image"
                                       :src="comment.image"
                                       max-width="150"
                                       class="mt-2 rounded-xl shadow"
                                       ></v-img></p>
                              </v-card-text>
                           </v-card>
                        </v-col>
                     </v-row>
                     <!-- CLIENT -->
                     <v-row v-if="comment.is_admin_comment === 0" dense justify="end">
                        <v-col sm="11" md="10">
                           <v-card
                              flat
                              :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
                              >
                              <v-card-title class="justify-end custom-title">
                                 <p>
                                    {{ moment(comment.created_at).fromNow() }}
                                    <span class="ml-4">You</span>
                                 </p>
                              </v-card-title>
                              <v-card-text>
                                 <p class="bg-success">
                                    {{ comment?.comment }} 
                                    <v-img
                                       v-if="comment.image"
                                       :src="comment.image"
                                       max-width="150"
                                       class="mt-2 rounded-xl shadow"
                                       ></v-img>
                                 </p>
                              </v-card-text>
                           </v-card>
                        </v-col>
                     </v-row>
                  </div>
                  <div ref="scrollAnchor" class="scroll-anchor"></div>
               </v-card>
               <!-- type message -->
               <v-sheet class="input-field mb-3" 
                  :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'" 
                  v-if="ticket.status == 1">
                  <!-- Text input -->
                  <input 
                     type="text" 
                     placeholder="Reply Here" 
                     v-model="comment" 
                     @keyup.enter="submitReply(ticket?.id)" 
                     />
                  <!-- Image upload -->
                  <v-file-input
                     accept="image/*"
                     dense
                     hide-details
                     prepend-icon="mdi-image"
                     show-size
                     label="Attach Image"
                     @change="handleImageUpload"
                     ></v-file-input>
                  <!-- Send button -->
                  <v-btn tile small color="greenMain"
                     @click.prevent="submitReply(ticket?.id)"
                     :disabled="!comment?.trim() && !selectedImage"
                     :loading="isPendingReply">
                     <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 8L0.999999 15L5 8L1 0.999999L20 8Z" stroke="#172233" stroke-linecap="round" stroke-linejoin="round" />
                     </svg>
                  </v-btn>
                  <!-- Image preview -->
                  <v-img v-if="selectedImage" 
                     :src="imagePreview" 
                     max-width="150" 
                     class="mt-2 ml-2 rounded-xl shadow">
                  </v-img>
               </v-sheet>
            </v-tab-item>
         </v-tabs>
      </v-container>
   </div>
</template>
<script>
   import toast from "@/services/Notification";
   import { TICKETS__ACTIONS } from "@/store/action-types";
   import moment from 'moment';
   import { mapActions, mapState } from "vuex";
   
   export default {
     name: 'SupportTicket',
     
     data() {
       return {
         search: "",
         subject: "",
         description: "",
         comment: "",
         dialog: false,
         selectedOption: null,
         options: ["Account", "Deposit", "Withdraw", "Others"],
         selectedTab: 0,
         refreshInterval: null,
         lastMessageCount: 0,
         selectedImage: null,
         imagePreview: null,
         isPendingReply: false,
       };
     },
   
     computed: {
       ...mapState("tickets", ["tickets", "ticketDetails"]),
       
       filteredTickets() {
         if (!this.search.trim()) {
           return this.tickets;
         }
         const searchLower = this.search.toLowerCase();
         return this.tickets.filter((ticket) => {
           const subjectLower = ticket.subject.toLowerCase();
           return subjectLower.includes(searchLower);
         });
       },
     },
   
     watch: {
       ticketDetails: {
         deep: true,
         handler(newDetails) {
           if (newDetails?.ticketcomments) {
             const currentCount = newDetails.ticketcomments.length || 0;
             if (currentCount > this.lastMessageCount) {
               this.$nextTick(() => {
                 this.scrollToBottom();
               });
             }
             this.lastMessageCount = currentCount;
           }
         }
       }
     },
   
     methods: {
       moment,
       ...mapActions("tickets", [
         TICKETS__ACTIONS.CREATE,
         TICKETS__ACTIONS.DETAILS,
         TICKETS__ACTIONS.REPLY,
         TICKETS__ACTIONS.TICKETS,
       ]),
   
       async selectTicket(ticket, index) {
         this.selectedTab = index;
         await this[TICKETS__ACTIONS.DETAILS](ticket?.id);
         const currentTicket = this.ticketDetails;
         this.lastMessageCount = currentTicket?.ticketcomments?.length || 0;
       },
   
       scrollToBottom() {
         const messageCard = this.$refs.messageCard;
         if (messageCard && messageCard[this.selectedTab]) {
           const container = messageCard[this.selectedTab].$el;
           container.scrollTop = container.scrollHeight;
         }
       },
   
       startAutoRefresh() {
         if (this.refreshInterval) {
           clearInterval(this.refreshInterval);
         }
   
         this.refreshInterval = setInterval(async () => {
           try {
             await this[TICKETS__ACTIONS.TICKETS]();
             await this[TICKETS__ACTIONS.DETAILS]();
           } catch (error) {
             console.error('Error refreshing tickets:', error);
           }
         }, 3000);
       },
   
       stopAutoRefresh() {
         if (this.refreshInterval) {
           clearInterval(this.refreshInterval);
           this.refreshInterval = null;
         }
       },
   
       async createTicket() {
         try {
           if (!this.selectedOption) {
             toast.error("Please select a topic");
             return;
           }
           if (!this.description) {
             toast.error("Please wirite description");
             return;
           }
   
           const data = {
             subject:
               this.selectedOption === "Others"
                 ? this.subject
                 : this.selectedOption,
             description: this.description,
           };
   
           await this[TICKETS__ACTIONS.CREATE](data);
           await this[TICKETS__ACTIONS.TICKETS]();
           
           this.dialog = false;
           this.selectedOption = null;
           this.subject = "";
           this.description = "";
         } catch (error) {
           // Error is already handled in the store action
           console.log("Error in createTicket:", error);
         }
       },
   
         handleImageUpload(file) {
           if (!file) {
             this.selectedImage = null;
             this.imagePreview = null;
             return;
           }
           this.selectedImage = file;
   
           // image preview
           const reader = new FileReader();
           reader.onload = e => {
             this.imagePreview = e.target.result;
           };
           reader.readAsDataURL(file);
         },
          async submitReply(id) {
            if (!id && !this.comment?.trim() && !this.selectedImage) {
              toast.error('Ticket ID and comment or file are required');
              return;
            }
   
            try {
              this.isPendingReply = true;
          
              const payload = {
                id: id,
                comment: this.comment?.trim() || "",
                file: this.selectedImage || null
              };
          
              await this[TICKETS__ACTIONS.REPLY](payload);
          
              this.comment = '';
              this.selectedImage = null;
              this.imagePreview = null;
            await this[TICKETS__ACTIONS.DETAILS](id);
              this.$nextTick(() => this.scrollToBottom());
            } catch (error) {
              console.error(error);
            } finally {
              this.isPendingReply = false;
            }
          }
     },
   
     async mounted() {
       try {
         await this[TICKETS__ACTIONS.TICKETS]();
         await this[TICKETS__ACTIONS.DETAILS](this.tickets[0]?.id)
         if (this.ticketDetails) {
           this.lastMessageCount = this.ticketDetails?.ticketcomments?.length || 0;
         }
         this.startAutoRefresh();
         this.$nextTick(() => {
           this.scrollToBottom();
         });
       } catch (error) {
         console.error('Error mounting component:', error);
       }
     },
   
     beforeDestroy() {
       this.stopAutoRefresh();
     },
   };
</script>
<style lang="scss" scoped>
   .v-main__wrap{
   overflow-y: hidden !important;
   height: 100vh;
   }
   .support-wrapper {
   .input-search {
   max-width: 305px;
   }
   .custom-date-year {
   justify-content: center;
   padding-left: 0;
   .v-card__title {
   padding-left: 0;
   span {
   margin-left: 0;
   }
   }
   }
   .support-card__details {
   border-radius: 0;
   padding-top: 0 !important;
   .custom-alert {
   background: #039de9;
   color: #172233;
   border-radius: 0;
   &.theme--light {
   color: #fff;
   }
   p {
   font-weight: 400;
   font-size: 12px;
   line-height: 20px;
   letter-spacing: 0.01em;
   padding: 0;
   margin: 0;
   }
   }
   }
   }
</style>